import { render } from "./ProductQueryResults.vue?vue&type=template&id=392cbfa4&ts=true"
import script from "./ProductQueryResults.vue?vue&type=script&lang=ts"
export * from "./ProductQueryResults.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\src\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__